// A single client quote set inline in the page, deliberately unlike the card
// grid on the home page: About Me carries one or two of these as punctuation,
// not a review wall. Gisela picks which ones with the `highlighted` flag on
// each testimonial.
export type PullQuoteData = { id: number; quote: string; attribution: string }

export function QuoteMark({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
    </svg>
  )
}

export function PullQuote({ quote }: { quote: PullQuoteData | undefined }) {
  if (!quote) return null

  return (
    <figure className="m-0 mt-12 border-l-2 border-sage pl-6 sm:pl-8">
      <QuoteMark className="mb-4 h-6 w-6 text-sage" />
      <blockquote className="m-0 border-0 p-0">
        <p className="m-0 whitespace-pre-line text-ink-display" style={{ fontStyle: "italic" }}>
          {quote.quote}
        </p>
      </blockquote>
      <figcaption className="mt-4">
        <cite className="text-sm text-ink-muted not-italic">{quote.attribution}</cite>
      </figcaption>
    </figure>
  )
}
